import Holding from '../ui/Holding';
import { connect } from 'react-redux';
import { holdingSubmit, cancelSubmit } from '../../actions';

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    territoryCode: state.territory.code,
    content: state.content
  });

const mapDispatchToProps = dispatch =>
  ({
    onHoldingSubmit(payload) {
       dispatch(
         holdingSubmit(payload)
       );
    },
    onCancelSubmit(payload) {
       dispatch(
         cancelSubmit(payload)
       );
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Holding);

export default Container;
